<template>
    <div>
        <span @click="open" class="pi pi-play-circle text-white cursor-pointer inline-flex items-center justify-center"
            style="font-size: 100px; line-height: 1;"></span>

        <!-- Modal Overlay -->
        <transition name="fade">
            <div v-if="isOpen" class="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center px-4">
                <!-- Modal Content -->
                <div class="bg-white shadow-xl w-full max-w-3xl relative z-50 animate-scale-in">
                    <!-- Close Button Desktop -->
                    <div class="!hidden md:!block absolute -top-10 -right-10 transition z-50">
                        <p-button @click="close" rounded icon="pi pi-times" aria-label="Close video" size="large" severity="secondary" text
                            :style="{ color: colors.primary }">
                        </p-button>
                    </div>



                    <!-- Close Button Mobile -->
                    <div class="!block md:!hidden -top-10 -right-5 absolute transition z-50">
                        <p-button @click="close" rounded icon="pi pi-times" aria-label="Close video" size="large" severity="secondary" text
                            :style="{ color: colors.primary }">
                        </p-button>
                    </div>


                    <!-- Video -->
                    <div class="relative w-full pt-[56.25%] bg-black">
                        <iframe v-if="embedUrl" :src="embedUrl" frameborder="0" allow="autoplay; fullscreen"
                            allowfullscreen class="absolute top-0 left-0 w-full h-full rounded-b-2xl"></iframe>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { VideoT } from '@/types';
import { ref } from 'vue'
import { Button as PButton } from 'primevue';
import useTheme from '@/Hook/useTheme';

const props = defineProps<{
    video: VideoT
}>()

const isOpen = ref(false)
const embedUrl = ref('')

const { colors } = useTheme();

function getEmbedUrl(data: VideoT) {
    try {

        if (data.youtubeId) {
            return `https://www.youtube.com/embed/${data.youtubeId}?autoplay=1`
        }
        if (data.vimeoId) {
            return `https://player.vimeo.com/video/${data.vimeoId}?autoplay=1`
        }
    } catch (e) {
        console.warn('Invalid video URL')
    }

    return ''
}

function open() {
    embedUrl.value = getEmbedUrl(props.video)
    isOpen.value = true
}

function close() {
    embedUrl.value = ''
    isOpen.value = false
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@keyframes scale-in {
    0% {
        transform: scale(0.95);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.animate-scale-in {
    animation: scale-in 0.3s ease-out forwards;
}
</style>
